package com.essntl.features.message.domain.model

import com.essntl.features.message.domain.model.WhapiMessageModel.Status
import com.essntl.uikit.components.chat.contact.ContactUiState
import com.essntl.uikit.components.chat.conversation.ConversationType
import com.essntl.uikit.components.chat.conversation.overviewcard.ConversationOverviewUiState
import com.essntl.uikit.components.chat.message.MessageUiState

data class WhapiChatModel(
    val id: String,
    val timestamp: Int,
    val unreadCount: Int?,
    val lastMessage: WhapiMessageModel?,
    val name: String?,
    val phoneNumber: String,
    val type: ChatType,
    val source: String?,
    val participants: List<GroupParticipantModel>?
) {

    fun toUiState(contact: ContactUiState, participants: List<String>? = null): ConversationOverviewUiState =
        ConversationOverviewUiState(
            conversationId = id,
            contact = contact,
            conversationType = ConversationType.Whatsapp,
            lastMessage = getLastMessageText(),
            isCurrentUserSender = lastMessage?.fromMe == true && lastMessage.type == WhapiMessageModel.Type.Text,
            unreadMessages = unreadCount ?: 0,
            dateTime = lastMessage?.timestamp.toString(),
            lastMessageStatus = when (lastMessage?.status) {
                Status.Pending -> MessageUiState.Status.Pending
                Status.Delivered -> MessageUiState.Status.Delivered
                Status.Read -> MessageUiState.Status.Read
                null -> null
            },
            type = when (type) {
                ChatType.Contact -> ConversationOverviewUiState.ChatType.Contact
                ChatType.Group -> ConversationOverviewUiState.ChatType.Group
                ChatType.Unknown -> ConversationOverviewUiState.ChatType.Unknown
            },
            participants = participants
        )

    private fun getLastMessageText(): String =
        when (lastMessage?.type) {
            WhapiMessageModel.Type.Text -> lastMessage.text
                ?: if (type == ChatType.Group)
                    "You created this group"
                else
                    ""

            WhapiMessageModel.Type.Image ->
                if (lastMessage.fromMe)
                    "You sent an image"
                else
                    "Sent an image"

            WhapiMessageModel.Type.Voice ->
                if (lastMessage.fromMe)
                    "You sent a voice message"
                else
                    "Sent a voice message"

            WhapiMessageModel.Type.Action -> {
                val from = if (lastMessage.fromMe)
                    "You"
                else
                    lastMessage.fromName?.split(" ")?.firstOrNull() ?: lastMessage.from


                from +
                    (if (lastMessage.action?.emoji != null)
                        " reacted ${lastMessage.action.emoji} to a message"
                    else " removed a react")
            }

            else -> ""
        }

    enum class ChatType {
        Contact,
        Group,
        Unknown,
    }
}